import { useSyncExternalStore } from 'react';
import mqttService from '../../../services/mqtt/mqttService';

export function useMqttIsConnected(): boolean {
  return useSyncExternalStore(mqttService.subscribeIsConnected, mqttService.getIsConnected, mqttService.getIsConnected);
}
